import React from 'react';
import { Button, Modal, Form, Segment, Dimmer, Loader, Grid, Dropdown } from "semantic-ui-react";
import { apiGet, apiPost, apiPut, apiDelete } from '../services/apiClient';
import { getCurrentUserCompanyId, getCurrentUserId, getRoles } from '../services/userRights';
import { toast } from 'react-toastify';
import moment from 'moment';
import DatePicker from '../components/DatePicker/DatePicker';
import IncomingParcelDropdown from '../components/Dropdowns/IncomingParcelDropdown';
import RecipientDropdown from '../components/Dropdowns/RecipientDropdown';

export default class CreateIncomingParcelModal extends React.Component {
    constructor(args) {
        super(args);

        this.state = {
            loading: false,
            errors: {},
            form: {
                parcelType: 'Документы',
                receivedDate: new Date(),
                recipientName: '',
                recipientUserId: null,
                senderName: '',
                comment: '',
                receiptLocation: '',
                documentPath: null
            },
            parcelTypes: [
                { key: 'doc', value: 'Документы', text: 'Документы' },
                { key: 'cargo', value: 'Груз', text: 'Груз' }
            ],
            // recipients больше не нужны - используются в RecipientDropdown
            file: null,
            isDragOver: false,
            existingFiles: []
        };

        this.fileInputRef = React.createRef();
        this._isMounted = false;
    }

    componentDidMount() {
        this._isMounted = true;
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    componentDidUpdate(prevProps) {
        if (this.props.open && !prevProps.open) {
            if (this.props.editingParcelId) {
                this.loadParcelData(this.props.editingParcelId);
            } else {
                this.resetForm();
            }
            // Данные получателей загружаются автоматически в RecipientDropdown
        }
    }

    resetForm() {
        this.setState({
            errors: {},
            form: {
                parcelType: 'Документы',
                receivedDate: new Date(),
                recipientName: '',
                recipientUserId: null,
                senderName: '',
                comment: '',
                receiptLocation: '',
                documentPath: null
            },
            recipients: [],
            file: null,
            isDragOver: false,
            existingFiles: []
        });
        if (this.fileInputRef.current) {
            this.fileInputRef.current.value = '';
        }
    }

    // Метод больше не нужен - убираем автоматическую подстановку места получения





    loadParcelData = (parcelId) => {
        if (!this._isMounted) return;
        this.setState({ loading: true });
        
        // Загружаем данные отправления и файлы параллельно
        Promise.all([
            apiGet(`incoming-parcels/${parcelId}`),
            apiGet(`incoming-parcels/${parcelId}/files`)
        ])
            .then(([parcelData, filesData]) => {
                if (!this._isMounted) return;
                
                console.log('=== LOADING FILES FROM SERVER ===');
                console.log('Raw files response:', filesData);
                
                // Проверяем каждый файл
                if (filesData && filesData.entries) {
                    console.log('Found', filesData.entries.length, 'files:');
                    filesData.entries.forEach((file, index) => {
                        console.log(`File ${index}:`, {
                            id: file.id,
                            key: file.key,
                            fileName: file.fileName,
                            contentType: file.contentType,
                            createdAt: file.createdAt,
                            downloadUrl: `/incoming-parcels/files/${file.key}`
                        });
                    });
                } else {
                    console.log('No files found or invalid response structure');
                }
                console.log('=== END FILES LOADING ===');
                
                // Если есть получатель, добавляем его в список recipients
                const recipients = [];
                if (parcelData.recipientUserId && parcelData.recipientName) {
                    recipients.push({
                        key: parcelData.recipientUserId,
                        value: parcelData.recipientUserId,
                        text: parcelData.recipientName
                    });
                }
                
                this.setState({
                    form: {
                        parcelType: parcelData.parcelType || 'Документы',
                        receivedDate: parcelData.receivedDate ? moment(parcelData.receivedDate).toDate() : new Date(),
                        recipientName: parcelData.recipientName || '',
                        recipientUserId: parcelData.recipientUserId || null,
                        senderName: parcelData.senderName || '',
                        comment: parcelData.comment || '',
                        receiptLocation: parcelData.receiptLocation || '',
                        documentPath: null, // Файлы обрабатываются отдельно
                        deliveredDate: parcelData.deliveredDate ? moment(parcelData.deliveredDate).toDate() : null,
                        status: parcelData.status === 1 || parcelData.status === "Delivered" ? "Delivered" : "Received",
                    },
                    recipients: recipients,
                    existingFiles: filesData.entries || [],
                    loading: false,
                    errors: {}
                });
            })
            .catch(error => {
                if (!this._isMounted) return;
                console.error('Ошибка загрузки данных отправления:', error);
                toast.error('Ошибка загрузки данных отправления');
                this.setState({ loading: false });
            });
    }

    handleInputChange = (field, value) => {
        this.setState(prevState => ({
            form: {
                ...prevState.form,
                [field]: value
            },
            errors: {
                ...prevState.errors,
                [field]: null
            }
        }));
    }

    handleFileSelect = (file) => {
        if (!file) return;

        console.log('=== FILE SELECTED ===');
        console.log('File name:', file.name);
        console.log('File size:', file.size, 'bytes');
        console.log('File type:', file.type);
        console.log('File last modified:', new Date(file.lastModified));

        // Проверяем размер файла (максимум 10MB)
        const maxSize = 10 * 1024 * 1024;
        if (file.size > maxSize) {
            toast.error('Размер файла не должен превышать 10 МБ');
            return;
        }

        // Проверяем тип файла
        const allowedTypes = [
            'application/pdf',
            'image/jpeg',
            'image/png',
            'image/gif',
            'application/msword',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'application/vnd.ms-excel',
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        ];

        if (!allowedTypes.includes(file.type)) {
            console.log('File type not allowed. Allowed types:', allowedTypes);
            toast.error('Недопустимый тип файла');
            return;
        }

        console.log('File passed validation, setting state');
        this.setState({ file });
    }

    handleFileInputChange = (e) => {
        const file = e.target.files[0];
        this.handleFileSelect(file);
    }

    handleDrop = (e) => {
        e.preventDefault();
        this.setState({ isDragOver: false });
        
        const files = e.dataTransfer.files;
        if (files.length > 0) {
            this.handleFileSelect(files[0]);
        }
    }

    handleDragOver = (e) => {
        e.preventDefault();
        this.setState({ isDragOver: true });
    }

    handleDragLeave = (e) => {
        e.preventDefault();
        this.setState({ isDragOver: false });
    }

    removeFile = () => {
        this.setState({ file: null });
        if (this.fileInputRef.current) {
            this.fileInputRef.current.value = '';
        }
    }

    // Проверка, может ли пользователь редактировать пользователей
    canEditUsers = () => {
        const roles = getRoles() || [];
        // Кнопка карандаша видна только для Клиентского администратора (ClientAdmin)
        return roles.includes('ClientAdmin');
    }

    // Обработка нажатия кнопки карандашика для пользователей
    handleEditUser = () => {
        const { form } = this.state;
        
        if (form.recipientUserId) {
            // Если пользователь выбран - переходим к редактированию
            window.open(`/admin/users/${form.recipientUserId}`, '_blank');
        } else {
            // Если пользователь не выбран - переходим к созданию нового
            window.open('/admin/users/new', '_blank');
        }
    }

    validateForm = () => {
        const { form } = this.state;
        const errors = {};

        if (!form.parcelType || form.parcelType.trim() === '') {
            errors.parcelType = 'Поле обязательно для заполнения';
        }

        if (!form.recipientUserId) {
            errors.recipientName = 'Необходимо выбрать получателя из списка';
        }

        if (!form.senderName || form.senderName.trim() === '') {
            errors.senderName = 'Поле обязательно для заполнения';
        }

        // Проверяем длину полей согласно ограничениям БД
        if (form.senderName && form.senderName.length > 255) {
            errors.senderName = 'Отправитель не должен превышать 255 символов';
        }

        if (form.recipientName && form.recipientName.length > 255) {
            errors.recipientName = 'Имя получателя не должно превышать 255 символов';
        }

        if (form.receiptLocation && form.receiptLocation.length > 255) {
            errors.receiptLocation = 'Место получения не должно превышать 255 символов';
        }

        if (form.comment && form.comment.length > 1000) {
            errors.comment = 'Комментарий не должен превышать 1000 символов';
        }

        this.setState({ errors });
        return Object.keys(errors).length === 0;
    }

    handleSubmit = () => {
        if (!this.validateForm()) {
            toast.error('Пожалуйста, заполните все обязательные поля');
            return;
        }

        this.setState({ loading: true });

        const requestData = {
            ...this.state.form,
            receivedDate: moment(this.state.form.receivedDate).toISOString()
        };

        if (this.props.editingParcelId) {
            // Режим редактирования
            const updateData = {
                id: this.props.editingParcelId,
                ...requestData
            };

            apiPut('incoming-parcels/update', updateData)
                .then(() => {
                    // Загружаем файл, если он есть
                    if (this.state.file) {
                        console.log('=== UPLOADING FILE (EDIT MODE) ===');
                        console.log('File to upload:', {
                            name: this.state.file.name,
                            size: this.state.file.size,
                            type: this.state.file.type
                        });
                        console.log('Upload URL:', `incoming-parcels/${this.props.editingParcelId}/upload`);
                        
                        const formData = new FormData();
                        formData.append('file', this.state.file);
                        
                        console.log('FormData entries:');
                        for (let pair of formData.entries()) {
                            console.log(pair[0], pair[1]);
                        }

                        return apiPost(`incoming-parcels/${this.props.editingParcelId}/upload`, formData)
                            .then(result => {
                                console.log('Upload response (edit mode):', result);
                                return result;
                            })
                            .catch(error => {
                                console.error('Upload error (edit mode):', error);
                                throw error;
                            });
                    }
                })
                .then(() => {
                    if (!this._isMounted) return;
                    this.setState({ loading: false });
                    toast.success('Запись обновлена!');
                    if (this.props.onSuccess) {
                        this.props.onSuccess();
                    }
                })
                .catch(err => {
                    if (!this._isMounted) return;
                    this.setState({ loading: false });
                    console.error('Error updating incoming parcel:', err);
                    
                    if (err.response && err.response.data && err.response.data.errors) {
                        this.setState({ errors: err.response.data.errors });
                        toast.error('Проверьте правильность заполнения полей');
                    } else {
                        toast.error('Ошибка при обновлении входящего отправления');
                    }
                });
        } else {
            // Режим создания
            apiPost('incoming-parcels/create', requestData)
                .then(response => {
                    const incomingParcelId = response.id;
                    
                    // Затем загружаем файл, если он есть
                    if (this.state.file) {
                        console.log('=== UPLOADING FILE (CREATE MODE) ===');
                        console.log('File to upload:', {
                            name: this.state.file.name,
                            size: this.state.file.size,
                            type: this.state.file.type
                        });
                        console.log('Upload URL:', `incoming-parcels/${incomingParcelId}/upload`);
                        console.log('Parcel ID:', incomingParcelId);
                        
                        const formData = new FormData();
                        formData.append('file', this.state.file);
                        
                        console.log('FormData entries:');
                        for (let pair of formData.entries()) {
                            console.log(pair[0], pair[1]);
                        }

                        return apiPost(`incoming-parcels/${incomingParcelId}/upload`, formData)
                            .then(result => {
                                console.log('Upload response (create mode):', result);
                                return incomingParcelId;
                            })
                            .catch(error => {
                                console.error('Upload error (create mode):', error);
                                throw error;
                            });
                    }
                    
                    return incomingParcelId;
                })
                .then(() => {
                    if (!this._isMounted) return;
                    this.setState({ loading: false });
                    toast.success('Запись зарегистрирована!');
                    this.resetForm();
                    if (this.props.onSuccess) {
                        this.props.onSuccess();
                    }
                })
                .catch(err => {
                    if (!this._isMounted) return;
                    this.setState({ loading: false });
                    console.error('Error creating incoming parcel:', err);
                    
                    if (err.response && err.response.data && err.response.data.errors) {
                        this.setState({ errors: err.response.data.errors });
                        toast.error('Проверьте правильность заполнения полей');
                    } else {
                        toast.error('Ошибка при создании входящего отправления');
                    }
                });
        }
    }

    deleteExistingFile = (fileId) => {
        if (window.confirm('Вы уверены, что хотите удалить этот файл?')) {
            apiDelete(`incoming-parcels/${this.props.editingParcelId}/files/${fileId}`)
                .then(() => {
                    if (!this._isMounted) return;
                    toast.success('Файл удален');
                    // Обновляем список файлов
                    const updatedFiles = this.state.existingFiles.filter(f => f.id !== fileId);
                    this.setState({ existingFiles: updatedFiles });
                })
                .catch(error => {
                    if (!this._isMounted) return;
                    console.error('Ошибка удаления файла:', error);
                    toast.error('Ошибка удаления файла');
                });
        }
    }

    renderFileUpload() {
        const { file, isDragOver, existingFiles } = this.state;

        return (
            <div style={{ marginTop: '15px' }}>
                {/* Существующие файлы */}
                {existingFiles.length > 0 && (
                    <div style={{ marginBottom: '15px' }}>
                        <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600' }}>
                            Прикрепленные файлы:
                        </label>
                        {existingFiles.map(existingFile => (
                            <div key={existingFile.id} style={{ 
                                display: 'flex', 
                                alignItems: 'center', 
                                padding: '8px 12px', 
                                border: '1px solid #d2d6de',
                                borderRadius: '4px',
                                backgroundColor: '#f9f9f9',
                                marginBottom: '5px'
                            }}>
                                <span style={{ color: '#3c8dbc', marginRight: '8px' }}>📄</span>
                                <a 
                                    href="#"
                                    style={{ 
                                        color: '#3c8dbc', 
                                        textDecoration: 'none',
                                        flex: 1,
                                        cursor: 'pointer'
                                    }}
                                    onClick={(e) => {
                                        e.preventDefault();                                        
                                        try {
                                            // Формируем URL точно как в проекте: getApiBaseUrl() + путь
                                            const baseUrl = typeof getApiBaseUrl === 'function' ? getApiBaseUrl() : '/';
                                            const fileUrl = baseUrl + "incoming-parcels/file/" + existingFile.key + "/download";
                                            
                                            // Используем window.location.href как везде в проекте для прямого скачивания
                                            window.location.href = fileUrl;
                                            
                                        } catch (error) {
                                            toast.error('Ошибка при скачивании файла');
                                        }
                                    }}
                                >
                                    {existingFile.fileName}
                                </a>
                                <Button 
                                    type="button" 
                                    size="mini"
                                    color="red"
                                    onClick={() => this.deleteExistingFile(existingFile.id)}
                                >
                                    ✕
                                </Button>
                            </div>
                        ))}
                    </div>
                )}

                {/* Область загрузки нового файла */}
                <div>
                    <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600' }}>
                        {existingFiles.length > 0 ? 'Добавить еще файл:' : 'Прикрепить файл:'}
                    </label>
                    <div 
                        className={`file-upload-area ${isDragOver ? 'drag-over' : ''}`}
                        onDrop={this.handleDrop}
                        onDragOver={this.handleDragOver}
                        onDragLeave={this.handleDragLeave}
                        onClick={() => this.fileInputRef.current.click()}
                        style={{
                            border: '2px dashed #d2d6de',
                            borderRadius: '4px',
                            padding: '30px 20px',
                            textAlign: 'center',
                            cursor: 'pointer',
                            backgroundColor: isDragOver ? '#e8f4f8' : '#f9f9f9',
                            borderColor: isDragOver ? '#3c8dbc' : '#d2d6de',
                            minHeight: '80px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            flexDirection: 'column',
                            transition: 'all 0.3s ease'
                        }}
                    >
                        <input
                            type="file"
                            ref={this.fileInputRef}
                            style={{ display: 'none' }}
                            onChange={this.handleFileInputChange}
                            accept=".pdf,.doc,.docx,.xls,.xlsx,.jpg,.jpeg,.png,.gif"
                        />
                        
                        {!file ? (
                            <div style={{ color: '#666' }}>
                                <div style={{ fontSize: '32px', color: '#135CA9', marginBottom: '10px' }}>
                                    ☁️
                                </div>
                                <p style={{ margin: '5px 0', fontSize: '14px' }}>Перетащите файл в это окно</p>
                                <p style={{ margin: '5px 0', fontSize: '14px' }}>или выберите</p>
                                <p style={{ fontSize: '11px', color: '#999', marginTop: '8px' }}>Максимальный размер файла: 10 МБ</p>
                            </div>
                        ) : (
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#333', fontWeight: '500' }}>
                                <span style={{ color: '#3c8dbc', marginRight: '8px' }}>📄</span>
                                <span>{file.name}</span>
                                <Button 
                                    type="button" 
                                    size="mini"
                                    color="red"
                                    style={{ marginLeft: '10px' }}
                                    onClick={(e) => { e.stopPropagation(); this.removeFile(); }}
                                >
                                    ✕
                                </Button>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    }

    render() {
        const { open, onClose } = this.props;
        const { loading, errors, form, parcelTypes } = this.state;

        return (
            <Modal
                open={open}
                onClose={onClose}
                closeIcon
                size="small"
                style={{ width: '450px !important' }}
            >
                <Modal.Header>
                    {this.props.editingParcelId ? 'Редактировать входящее отправление' : 'Создать входящее отправление'}
                </Modal.Header>
                
                <Modal.Content style={{ padding: '20px' }}>
                    <Dimmer active={loading} inverted>
                        <Loader size='medium'/>
                    </Dimmer>
                    
                    <Form>
                        <Form.Field error={!!errors.parcelType}>
                            <label>Тип посылки <span style={{ color: 'red' }}>*</span></label>
                            <Dropdown
                                selection
                                options={parcelTypes}
                                value={form.parcelType}
                                onChange={(e, { value }) => this.handleInputChange('parcelType', value)}
                                disabled={loading}
                                style={{ width: '100%' }}
                            />
                            {errors.parcelType && <div style={{ color: 'red', fontSize: '12px', marginTop: '5px' }}>{errors.parcelType}</div>}
                        </Form.Field>

                        <Form.Field>
                            <label>Дата получения</label>
                            <DatePicker
                                name="receivedDate"
                                value={form.receivedDate}
                                onChange={(e, { value }) => this.handleInputChange('receivedDate', value)}
                                disabled={loading}
                                dateFormat="dd.MM.yyyy"
                                placeholderText="дд.мм.гггг"
                                fluid
                            />
                        </Form.Field>
                        {/* Статус (можно менять) */}
                        {this.props.editingParcelId && (
                            <React.Fragment>
                                <Form.Field>
                                    <label>Статус</label>
                                    <Dropdown
                                        selection
                                        options={[
                                            { key: 'received', value: 'Received', text: 'Получено' },
                                            { key: 'delivered', value: 'Delivered', text: 'Вручено' }
                                        ]}
                                        value={form.status || 'Received'}
                                        onChange={(e, { value }) => this.handleInputChange('status', value)}
                                        disabled={loading}
                                        style={{ width: '100%' }}
                                    />
                                </Form.Field>
                                {/* Дата вручения только если статус Вручено */}
                                {form.status === 'Delivered' && (
                                    <Form.Field>
                                        <label>Дата вручения</label>
                                        <DatePicker
                                            name="deliveredDate"
                                            value={form.deliveredDate}
                                            onChange={(e, { value }) => this.handleInputChange('deliveredDate', value)}
                                            disabled={loading}
                                            dateFormat="dd.MM.yyyy"
                                            placeholderText="дд.мм.гггг"
                                            fluid
                                        />
                                    </Form.Field>
                                )}
                            </React.Fragment>
                        )}
                        {/* Дата вручения только для просмотра, если статус Вручено (для новых/старых записей) */}
                        {this.props.editingParcelId && form.status === 'Delivered' && (
                            <Form.Field>
                                <label>Дата вручения</label>
                                <div style={{ padding: '8px 0', fontWeight: 500 }}>
                                    {form.deliveredDate ? moment(form.deliveredDate).format('DD.MM.YYYY') : <span style={{ color: '#aaa' }}>—</span>}
                                </div>
                            </Form.Field>
                        )}

                        <Form.Field error={!!errors.recipientName}>
                            <label>Получатель <span style={{ color: 'red' }}>*</span></label>
                            <RecipientDropdown
                                name="recipientName"
                                value={form.recipientName}
                                recipientUserId={form.recipientUserId}
                                onChange={(field, value) => this.handleInputChange(field, value)}
                                placeholder="Выберите из списка"
                                searchErrorText="Ошибка поиска получателей"
                                disabled={loading}
                                error={!!errors.recipientName}
                                onEditUser={this.handleEditUser}
                                canEditUsers={this.canEditUsers()}
                            />
                            {errors.recipientName && <div style={{ color: 'red', fontSize: '12px', marginTop: '5px' }}>{errors.recipientName}</div>}
                            <div style={{ fontSize: '12px', color: '#666', marginTop: '5px' }}>
                                Введите символ для поиска по справочнику пользователей вашей компании.
                            </div>
                        </Form.Field>

                        <Form.Field error={!!errors.senderName}>
                            <label>Отправитель <span style={{ color: 'red' }}>*</span></label>
                            <IncomingParcelDropdown
                                name="senderName"
                                value={form.senderName}
                                type="senders"
                                onChange={(field, value) => this.handleInputChange(field, value)}
                                placeholder="Введите название отправителя"
                                searchErrorText="Ошибка поиска отправителей"
                                disabled={loading}
                                error={!!errors.senderName}
                                allowAdditions={true}
                            />
                            {errors.senderName && <div style={{ color: 'red', fontSize: '12px', marginTop: '5px' }}>{errors.senderName}</div>}
                            <div style={{ fontSize: '12px', color: '#666', marginTop: '5px' }}>
                                Введите символ для поиска по ранее использованным отправителям.
                            </div>
                        </Form.Field>

                        <Form.Field>
                            <label>Место получения</label>
                            <IncomingParcelDropdown
                                name="receiptLocation"
                                value={form.receiptLocation}
                                type="locations"
                                onChange={(field, value) => this.handleInputChange(field, value)}
                                placeholder="Выберите из списка"
                                searchErrorText="Ошибка поиска мест получения"
                                disabled={loading}
                                allowAdditions={true}
                            />
                            <div style={{ fontSize: '12px', color: '#666', marginTop: '5px' }}>
                                Введите символ для поиска по ранее использованным местам получения.
                            </div>
                        </Form.Field>

                        <Form.Field error={!!errors.comment}>
                            <label>Комментарий</label>
                            <textarea
                                value={form.comment}
                                onChange={(e) => this.handleInputChange('comment', e.target.value)}
                                placeholder="Введите текст вашего комментария"
                                disabled={loading}
                                rows={3}
                                maxLength={1000}
                                style={{ width: '100%', resize: 'vertical' }}
                            />
                            <div style={{ 
                                fontSize: '12px', 
                                color: form.comment && form.comment.length > 900 ? '#ff6b6b' : '#666', 
                                marginTop: '5px', 
                                textAlign: 'right',
                                fontWeight: form.comment && form.comment.length > 900 ? 'bold' : 'normal'
                            }}>
                                {form.comment ? form.comment.length : 0} / 1000 символов
                            </div>
                            {errors.comment && <div style={{ color: 'red', fontSize: '12px', marginTop: '5px' }}>{errors.comment}</div>}
                        </Form.Field>

                        {this.renderFileUpload()}
                    </Form>
                </Modal.Content>

                <Modal.Actions style={{ padding: '15px 20px' }}>
                    <Button onClick={onClose} disabled={loading}>
                        Отмена
                    </Button>
                    <Button 
                        primary
                        onClick={this.handleSubmit} 
                        disabled={loading}
                    >
                        {loading ? 'Сохранение...' : (this.props.editingParcelId ? 'Сохранить' : 'Зарегистрировать')}
                    </Button>
                </Modal.Actions>
            </Modal>
        );
    }
} 


// WEBPACK FOOTER //
// ./App/modals/createIncomingParcelModal.jsx